export default __webpack_public_path__ + "static/SR USA - Hoja de Seguridad - Color Caramelo (Polvo)-b55d303059ee1d56e75f8505ec274446.pdf";